import { useTranslation } from "react-i18next";
import { Shield, RefreshCw } from "lucide-react";
import { PaymentBadges } from "@/components/payments/PaymentBadges";

export const TrustIndicators = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch max-w-4xl mx-auto py-8">
      {/* Accepted payment methods */}
      <div className="card-premium rounded-xl border border-primary/15 px-6 py-4 flex items-center gap-3 hover:shadow-glass-hover transition-all duration-300 flex-1">
        <Shield className="w-6 h-6 text-primary shrink-0" />
        <div className="space-y-1.5 min-w-0">
          <p className="font-semibold text-sm text-foreground">
            {t('pricing.security.securePayment')}
          </p>
          <PaymentBadges hideLabel showStripeBadge />
          <p className="text-xs text-muted-foreground leading-relaxed">
            {t('pricing.security.securePaymentDescription')}
          </p>
        </div>
      </div>

      {/* Money-Back Guarantee */}
      <div className="card-premium rounded-xl border border-primary/15 px-6 py-4 flex items-center gap-3 hover:shadow-glass-hover transition-all duration-300 flex-1">
        <RefreshCw className="w-6 h-6 text-primary shrink-0" />
        <div className="space-y-1 min-w-0">
          <p className="font-semibold text-sm text-foreground">
            {t('pricing.security.moneyBackGuarantee')}
          </p>
          <p className="text-xs text-muted-foreground leading-relaxed">
            {t('pricing.security.moneyBackDescription')}
          </p>
        </div>
      </div>
    </div>
  );
};
